// **********************************************************
// Packages Slider
// **********************************************************

const packagesSlider = document.querySelectorAll('[data-slider="packages-slider"]');
const cartIcon = document.querySelector('.btn--cart-button');

const packagesSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 16,
  speed: 600,
  watchOverflow: true,
  pagination: {
    el: '.packages__pagination-top',
    clickable: true,
    renderBullet(index, className) {
      return `<span class="${className}"></span>`;
    },
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1199: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  },
};

const getItemsFromCookie = () => JSON.parse(decodeURIComponent(Cookies.get('cart') || '[]'));

const getCartHtmlResponse = () => {
  const formDataInput = new FormData();
  formDataInput.append('inputs', JSON.stringify(getItemsFromCookie()));
  formDataInput.append('lang', localData.lang);
  formDataInput.append('action', 'getCartHtml');
  axios
    .post(localData.apiURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200 && document.querySelector('.order-summary__body')) {
        if (document.querySelector('.sc-payment-summary')) {
          document.querySelector('.sc-payment-summary').classList.toggle('is-hidden', !response.data.html);
        }
        if (document.querySelector('#payment-summary-price')) {
          if (response.data.price_reduced) {
            document.querySelector('#payment-summary-price').innerHTML = response.data.price_reduced;
          } else {
            document.querySelector('#payment-summary-price').innerHTML = response.data.price;
          }
        }
        document.querySelector('.order-summary__body').innerHTML = response.data.html;
        document.querySelector('.order-summary__price-row .text-right').innerHTML = response.data.price_without_vat;
        document.querySelector('.order-summary__price-row .vat-price').innerHTML = response.data.vat;
        document.querySelector('.order-summary__price-row .text--2xl').innerHTML = response.data.price_reduced || response.data.price;
        if (document.querySelector('.order-summary__price-row .code-text')) {
          document.querySelector('.order-summary__price-row .code-text').innerHTML = response.data.code;
          document.querySelector('.order-summary__price-row .code-reduce').innerHTML = response.data.code_discount;
        }
        initCounters();
        checkAndUpdateWarning();
        if (response.data.price) {
          cartIcon.classList.remove('d-none');
          cartIcon.querySelector('.btn__badge').innerHTML = response.data.quantity;
        }
      }
    });
};

const setItemToCookie = (data) => {
  const dataItems = {};
  const currentData = getItemsFromCookie();
  Object.keys(currentData).forEach((key) => {
    dataItems[`${currentData[key].date}_${currentData[key].type}`] = currentData[key];
  });
  dataItems[`${data.date}_${data.type}`] = data;
  if ((data.date === 'gift' && Number(data.quantity) === 0) || (Number(data.adults) + Number(data.children || 0) === 0)) {
    delete dataItems[`${data.date}_${data.type}`];
  }
  if (JSON.stringify(dataItems) !== '{}') {
    Cookies.set('cart', JSON.stringify(dataItems), { expires: 14, secure: true });
  } else {
    deleteSecureCookie('cart');
  }
};

packagesSlider.forEach((el) => {
  const packagesSliderParent = el.closest('.packages');
  const topPaginationElement = packagesSliderParent.querySelector('.packages__pagination-top');
  const bottomPaginationElement = packagesSliderParent.querySelector('.packages__pagination-bottom');

  const packagesSliderInit = new Swiper(el, packagesSliderOptions);

  // Created Custom Multiple Pagination For Slider
  // Render bullet function
  packagesSliderInit.pagination.renderBullet = (index, className) => `<span class="${className}">${index + 1}</span>`;

  // Generate top and bottom pagination HTML
  const topBullets = Array.from(topPaginationElement.querySelectorAll('.swiper-pagination-bullet'));
  const bottomPaginationHtml = topBullets
    .map(
      (bullet) =>
        `<span class="swiper-pagination-bullet ${
          bullet.classList.contains('swiper-pagination-bullet-active') ? 'swiper-pagination-bullet-active' : ''
        }"></span>`,
    )
    .join('');

  // Update pagination elements
  // eslint-disable-next-line no-return-assign, no-param-reassign
  [topPaginationElement, bottomPaginationElement].forEach((element) => (element.innerHTML = bottomPaginationHtml));

  // Slide change event
  packagesSliderInit.on('slideChange', () => {
    const { activeIndex } = packagesSliderInit;
    [topPaginationElement, bottomPaginationElement].forEach((paginationElement) => {
      const bullets = paginationElement.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet, index) =>
        bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex),
      );
    });
  });

  // Click event on top pagination element
  topPaginationElement.addEventListener('click', (event) => {
    if (event.target.classList.contains('swiper-pagination-bullet')) {
      const index = Array.from(topPaginationElement.children).indexOf(event.target);
      packagesSliderInit.slideTo(index);
    }
  });

  // Click event on bottom pagination element
  bottomPaginationElement.addEventListener('click', (event) => {
    if (event.target.classList.contains('swiper-pagination-bullet')) {
      const index = Array.from(bottomPaginationElement.children).indexOf(event.target);
      packagesSliderInit.slideTo(index);
    }
  });

  const btnBuy = el.querySelectorAll('.btn--with-icon');
  btnBuy.forEach((item) => {
    item.addEventListener('click', async (btn) => {
      btn.preventDefault();
      const closestArticle = btn.target.closest('article');
      const data = {};
      data.date = closestArticle.dataset.date || 'gift';
      data.type = closestArticle.dataset.type;
      closestArticle.querySelectorAll('input').forEach((it) => {
        if (it.value) {
          data[it.name] = it.value;
        }
      });
      setAddRemoveNew(closestArticle, data)
      await setItemToCookie(data);
      getCartHtmlResponse();
    });
  });
});

if (Cookies.get('cart')) {
  getCartHtmlResponse();
  if (cartIcon) {
    cartIcon.classList.remove('d-none');
  }
  document.body.classList.add('has-summary');
}

if (document.querySelector('.payment-summary__popup-trigger-text')) {
  document.querySelector('.btn--open-header-menu').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.payment-summary__popup-trigger-text').click();
    document.querySelector('.picker__mobile-trigger').click();
  });
}
if (document.querySelector('.payment-summary__popup-trigger-text')) {
  document.querySelector('.btn--cart-button').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.payment-summary__popup-trigger-text').click();
  });
}
